import React, {useCallback, useContext} from "react";
import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import {useTheme} from "@mui/material/styles";
import {LiveblocksProvider, RoomProvider, useOthers} from "@liveblocks/react";
import {AuthContext} from "../../../context/AuthContext";
import {FetchContext} from "../../../context/FetchContext";

const PresenceAvatars = () => {
    const others = useOthers();
    const theme = useTheme();
    const people = [...new Map(
        others.map((user) => [user.id || user.connectionId, user])
    ).values()];

    return people.map(({connectionId, info = {}}, index) => {
        const name = info.name || info.email || "Workspace member";
        const tooltip = info.email ? `${info.email} is viewing` : `${name} is viewing`;
        const avatarStyle = {
            width: 28,
            height: 28,
            marginLeft: index ? "-7px" : 0,
            borderRadius: "50%",
            boxShadow: "0 0 0 2px var(--app-bg-surface)",
        };

        return (
            <Tooltip key={connectionId} title={tooltip}>
                {info.avatar ? (
                    <Box component="img" src={info.avatar} alt={name} sx={{...avatarStyle, objectFit: "cover"}}/>
                ) : (
                    <Box sx={{
                        ...avatarStyle,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: theme.palette.mode === "dark" ? "#2B6BFD" : "#000000",
                        color: "#ffffff",
                        fontSize: 12,
                        fontWeight: 600,
                    }}>
                        {name.charAt(0).toUpperCase()}
                    </Box>
                )}
            </Tooltip>
        );
    });
};

const CompositionPresence = ({compositionId}) => {
    const {getFreshToken} = useContext(AuthContext);
    const {authAxios} = useContext(FetchContext);
    const authorize = useCallback(async (room) => {
        const token = await getFreshToken();
        if (!room || !token) throw new Error("Unable to connect presence");
        const {data} = await authAxios.post("/liveblocks/auth", {room}, {
            headers: {Authorization: `Bearer ${token}`},
        });
        return data;
    }, [authAxios, getFreshToken]);

    if (!compositionId) return null;
    const room = `composition:${compositionId}`;

    return (
        <LiveblocksProvider authEndpoint={authorize}>
            <RoomProvider key={room} id={room}>
                <Box sx={{display: "flex", alignItems: "center"}}>
                    <PresenceAvatars/>
                </Box>
            </RoomProvider>
        </LiveblocksProvider>
    );
};

export default CompositionPresence;
